var angular = require('angular')

angular.module('AemReicoNewsletter')
  .controller('AemReicoNewsletterCtrl', ctrl)

ctrl.$inject = ['appLoader', 'reicoService', 'wgService', 'i18n']

function ctrl (appLoader, reicoService, wgService, i18n) {
  var vm = this

  vm.$onInit = function () {
    vm.isErrorBackend = false
    vm.emailId = 'email_' + guid()
    vm.gdprId = 'gdpr_' + guid()
    vm.emailRegex = /^[\w.+-]+@[\w]+(\.[\w]{2,})+$/
    vm.email = null
    vm.gdpr = false
    vm.showError = showError
    vm.register = register
    vm.showConfirmation = false
    vm.isRegisterResolving = false
    vm.agreement = (wgService.getParams() && wgService.getParams().agreement[i18n.langCode]) || null

    appLoader.hide()
  }

  function showError (fieldName) {
    return vm.form_newsletter.$submitted && vm.form_newsletter[fieldName].$invalid
  }

  function register () {
    if (vm.form_newsletter.$valid) {
      appLoader.show()
      vm.isRegisterResolving = true
      reicoService.registerNewsletter({ email: vm.email })
        .then(function (resp) {
          if (resp.status === 200) {
            vm.showConfirmation = true
          } else {
            vm.backendError = true
          }
        })
        .catch(function () {
          vm.isErrorBackend = true
        })
        .finally(function () {
          vm.isRegisterResolving = false
          appLoader.hide()
        })
    }
  }

  function guid () {
    function s4 () {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  }
}
